<template>
  <div ref="context-group-wrap" class="context-group-wrap">
    <cell-loader v-if="category.loading" />

    <context
      v-else
      class="context"
      :class="wrapOnTop ? 'floating' : ''"
      :context.sync="category.name"
      :context-id="category.id"
      :flows="flows"
      :has-flow-entity="hasFlowEntity"
      :is-pattern-view="isPatternView"
      @delete="deleteHandler"
      @update="name => updateContext({ id: category.id, name: name })"
    />
    <context-pairs
      v-if="!category.loading"
      class="pairs"
      :class="wrapOnTop ? 'floating' : ''"
      :flows="flows"
      :category="category"
      :is-pattern-view="isPatternView"
      :wrapTopReachHeader="wrapTopReachHeader"
      :wrapBottomFromHeaderSpace="wrapBottomFromHeaderSpace"
      :scrollTop="scrollTop"
    />
    <or-confirm
      ref="delete-category-confirm"
      :title="$t('common.context.context_group.deleteModal.title')"
      class="delete-confirm-modal"
      @confirm="confirmDelete"
    >
      {{ $t('common.context.context_group.deleteModal.description') }}
    </or-confirm>
    <flow-entity-modal :id="category.id" targer="context" />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import KnowledgeBus from '@/KnowledgeBus'
import context from './context'
import contextPairs from './context_pairs'
import cellLoader from '../../table/table_stuff/cell_loader'
import flowEntityModal from '@/components/model/nlu-model/sidebar/flow_entities/flow_entity_modal'

export default {
  components: {
    context,
    contextPairs,
    cellLoader,
    flowEntityModal
  },

  created () {
    KnowledgeBus.$on(
      'context-group-flow-entity::append',
      this.openFlowEntityModal
    )
    KnowledgeBus.$on(
      'context-flow-entity::append',
      this.appendFrowEntityToContext
    )
    KnowledgeBus.$on('context-flow-entity::remove', this.removeFlowEntity)
  },

  beforeDestroy () {
    KnowledgeBus.$off(
      'context-group-flow-entity::append',
      this.openFlowEntityModal
    )
    KnowledgeBus.$off(
      'context-flow-entity::append',
      this.appendFrowEntityToContext
    )
    KnowledgeBus.$off('context-flow-entity::remove', this.removeFlowEntity)
  },

  mounted () {
    this.setWrapHeight()
    this.setOffsetTop()
  },

  props: {
    isPatternView: Boolean,
    category: Object,
    flows: Array,
    scrollTop: Number
  },

  computed: {
    wrapTopReachHeader () {
      return this.scrollTop >= this.offsetTop
    },

    wrapBottomBellowHeader () {
      return this.scrollTop < this.offsetTop + this.wrapHeight
    },

    wrapBottomFromHeaderSpace () {
      return this.offsetTop + this.wrapHeight - this.scrollTop - 64
    },

    wrapOnTop () {
      return this.wrapTopReachHeader && this.wrapBottomBellowHeader
    },

    hasFlowEntity () {
      return !_.isEmpty(this.category.model_features)
    }
  },

  data () {
    return {
      wrapHeight: Number,
      offsetTop: Number
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['deleteCategory', 'updateContext']),

    openFlowEntityModal (contextId) {
      if (contextId === this.category.id) {
        const currentflowEntity = _.isEmpty(this.category.model_features)
          ? ''
          : this.category.model_features[0]

        KnowledgeBus.$emit('flow-entity-modal::open', {
          currentflowEntity: currentflowEntity,
          target: 'context',
          targetId: contextId
        })
      }
    },

    async appendFrowEntityToContext ({ targetId, flowEntity }) {
      if (targetId === this.category.id) {
        await this.updateContext({
          id: this.category.id,
          name: this.category.name,
          model_features: [flowEntity]
        })
      }
    },

    async removeFlowEntity (targetId) {
      if (targetId === this.category.id) {
        await this.updateContext({
          id: this.category.id,
          name: this.category.name,
          model_features: []
        })
      }
    },

    deleteHandler () {
      this.$refs['delete-category-confirm'].open()
    },

    confirmDelete () {
      this.deleteCategory({ appId: this.category.id })
    },

    setWrapHeight () {
      this.wrapHeight = this.$refs['context-group-wrap'].clientHeight
    },

    setOffsetTop () {
      this.offsetTop = this.$refs['context-group-wrap'].offsetTop
    },

    resetOffsetTopAndWrapHeight () {
      this.setOffsetTop()
      this.setWrapHeight()
    }
  },

  watch: {
    scrollTop () {
      this.setOffsetTop()
      this.setWrapHeight()
    }
  }
}
</script>

<style lang="scss" scoped>
.context-group-wrap {
  display: flex;
  flex-direction: column;
  background: $or-white;

  .delete-confirm-modal {
    z-index: 4;
  }

  .context.floating {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;
    transition: all 0.2s ease;
  }

  .pairs.floating {
    margin-top: 32px;
  }
}
</style>
